<template>
  <div style="height: 100vh;">
    <!-- Logo 区域 -->
    <div
      class="logo"
      @click="$router.push('/')"
      :style="{ width: collapsed ? '80px' : '256px' }"
    >
      <!-- ✅ 圆形 logo 容器 -->
      <div class="logo-wrapper">
        <img :src="logo" alt="logo" class="logo-img" />
      </div>

      <!-- ✅ 只在未折叠时显示项目名 -->
      <span
        v-if="!collapsed"
        class="project-name"
      >
        {{ ProjectName }}
      </span>
    </div>

    <!-- 菜单 -->
    <a-menu
      theme="light"
      mode="inline"
      :selectedKeys="selectedKeys"
      :openKeys="openKeys"
      :inline-collapsed="collapsed"
      :style="{ width: collapsed ? '80px' : '256px' }"
      @click="switchView"
      @openChange="openChange"
    >
      <!-- 数据看板菜单项权限判断 -->
      <a-menu-item
        v-if="hasDashboardPermission"
        key="/home"
      >
        <a-icon type="home" />
        <span>数据看板</span>
      </a-menu-item>

      <!-- 根据权限过滤后的菜单 -->
      <a-sub-menu v-for="menu in filteredMenus" :key="menu.key">
        <span slot="title">
          <a-icon :type="menu.icon" />
          <span>{{ menu.name }}</span>
        </span>
        <a-menu-item
          v-for="submenu in menu.submenus"
          :key="submenu.key"
          @click="switchView(submenu)"
        >
          {{ submenu.name }}
        </a-menu-item>
      </a-sub-menu>
    </a-menu>
  </div>
</template>

<script>
import rawMenus from '@/menus.js'

export default {
  name: 'Sidebar',
  props: {
    collapsed: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      rawMenus,
      openKeys: [],
      selectedKeys: [],
      logo: require('@/assets/logo.png'),
      ProjectName: process.env.VUE_APP_PROJECT_NAME || '蓝天创业园物业管理系统'
    }
  },
  computed: {
    // 直接从根 state 读取 user 模块下的 permissions 数组
    permissions() {
      return this.$store.state.user.permissions || []
    },
    // 是否拥有全部权限（后端约定 permissions 中包含 "*" 表示超管）
    hasAllPermissions() {
      return this.permissions.includes('*')
    },
    // 过滤菜单：先过滤子菜单，再剔除空的顶层菜单
    filteredMenus() {
      // 超级管理员（permissions 包含 "*"）直接显示全部菜单
      if (this.hasAllPermissions) {
        return this.rawMenus
      }
      // 普通用户按 code 过滤
      return this.rawMenus
        .map(menu => ({
          ...menu,
          submenus: menu.submenus.filter(sub =>
            this.permissions.includes(sub.code)
          )
        }))
        .filter(menu => menu.submenus.length > 0)
    },
    // 数据看板菜单项权限判断
    hasDashboardPermission() {
      // 超级管理员直接拥有看板权限
      if (this.hasAllPermissions) return true
      // 否则按具体权限码控制
      return this.permissions.includes('dashboard_access')
    }
  },
  methods: {
    initialize() {
      this.changeRoute(this.$route.path)
    },
    switchView(item) {
      if (this.$route.path !== item.key) {
        this.$router.push(item.key)
      }
    },
    openChange(openKeys) {
      this.openKeys =
        Array.isArray(openKeys) && openKeys.length > 0
          ? [openKeys[openKeys.length - 1]]
          : []
    },
    changeRoute(path) {
      this.selectedKeys = [path]
      for (let m of this.rawMenus) {
        if (m.submenus.some(s => s.key === path)) {
          this.openKeys = [m.key]
          return
        }
      }
      this.openKeys = []
    }
  },
  watch: {
    $route(to) {
      this.changeRoute(to.path)
    }
  },
  created() {
    this.initialize()
  }
}
</script>

<style scoped>
.logo {
  font-weight: bold;
  font-size: 20px;
  height: 64px;
  padding: 12px 16px;
  border-bottom: 1px solid #6662;
  cursor: pointer;

  display: flex;
  align-items: center;
}

/* ✅ 圆形 + 阴影 + 悬浮动画 */
.logo-wrapper {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  overflow: hidden;

  display: flex;
  align-items: center;
  justify-content: center;

  box-shadow: 0 3px 8px rgba(0, 0, 0, 0.18);
  transition: transform 0.25s ease, box-shadow 0.25s ease;
}

/* ✅ 悬浮时轻微抬起 + 放大 + 阴影增强 */
.logo-wrapper:hover {
  transform: translateY(-2px) scale(1.05);
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.25);
}

/* ✅ 图标铺满圆形区域（让方形 logo 被裁成圆形） */
.logo-img {
  width: 100%;
  height: 100%;
  display: block;
  object-fit: cover;
}

/* 项目文字独立样式，便于统一控制 */
.project-name {
  color: #1890ff;
  margin-left: 8px;
  font-size: 14px;
  white-space: nowrap;
}
</style>
